import { render, staticRenderFns } from "./EditSkillDialog.vue?vue&type=template&id=d13eb3c0"
import script from "./EditSkillDialog.vue?vue&type=script&lang=js"
export * from "./EditSkillDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports